import { render, staticRenderFns } from "./JournalModes.vue?vue&type=template&id=70d6e2ca"
import script from "./JournalModes.vue?vue&type=script&lang=js"
export * from "./JournalModes.vue?vue&type=script&lang=js"
import style0 from "./JournalModes.vue?vue&type=style&index=0&id=70d6e2ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports